// Import Bootstrap
import 'bootstrap'

// Import styles
import '../stylesheets/application.scss'

// Import Vue and dependencies
import { createApp } from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import SessionChecker from '../components/SessionChecker.vue'

// Configure Axios CSRF token
const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
if (token) {
  axios.defaults.headers.common['X-CSRF-Token'] = token
}

// Function to mount Vue apps
function mountVueApps() {
  // Mount session checker if the element exists
  const sessionCheckerElement = document.getElementById('session-checker-app')
  if (sessionCheckerElement && !sessionCheckerElement.hasAttribute('data-vue-mounted')) {
    console.log('Mounting session checker app')
    const sessionApp = createApp(SessionChecker)
    sessionApp.mount('#session-checker-app')
    
    // Mark as mounted to prevent duplicate mounting
    sessionCheckerElement.setAttribute('data-vue-mounted', 'true')
  }
}

// Initialize Vue apps when the DOM is first loaded
document.addEventListener('DOMContentLoaded', mountVueApps)

// Re-initialize on Turbo Drive navigation
document.addEventListener('turbo:load', mountVueApps)
